import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background-color: #f5f5f5;
  border-radius: 0 0 8px 8px;
`;

export const OptionContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1rem;
`;

export const SelectContainer = styled.select`
  padding: 0.25rem;
  border: none;
  background-color: #f5f5f5;
`;

interface IButtonNextProp {
  hasNextPage: boolean;
}

interface IButtonPrevProp {
  hasPreviousPage: boolean;
}

export const ButtonPrev = styled.button<IButtonPrevProp>`
  padding: 0.25rem 0.5rem;
  margin-right: 0.5rem;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: ${({ hasPreviousPage }) => (hasPreviousPage ? 'pointer' : 'not-allowed')};

  &:hover {
    background-color: ${({ hasPreviousPage }) => (hasPreviousPage ? '#ccc' : 'none')};
  }
`;

export const ButtonNext = styled.button<IButtonNextProp>`
  padding: 0.25rem 0.5rem;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: ${({ hasNextPage }) => (hasNextPage ? 'pointer' : 'not-allowed')};
  margin-right: 1rem;

  &:hover {
    background-color: ${({ hasNextPage }) => (hasNextPage ? '#ccc' : 'none')};
  }
`;
